(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bosque-header"]) return;
  try {
    
  document.querySelectorAll('.bc-site-header').forEach((header) => {
    const toggle = header.querySelector('.bc-menu-toggle');
    const navigation = header.querySelector('.bc-main-nav');
    const megaItems = Array.from(header.querySelectorAll('[data-mega-menu-item]'));
    const closeTimers = new WeakMap();

    if (!toggle || !navigation || toggle.dataset.menuReady === 'true') return;

    const syncHeaderHeight = () => {
      document.documentElement.style.setProperty('--bc-header-stack-height', `${header.getBoundingClientRect().height}px`);
    };
    const headerObserver = new ResizeObserver(syncHeaderHeight);
    const observerController = new AbortController();
    headerObserver.observe(header);
    syncHeaderHeight();
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(header)) return;
      headerObserver.disconnect();
      observerController.abort();
    }, { signal: observerController.signal });

    const isDesktop = () => window.matchMedia('(min-width: 1200px)').matches;

    const setMegaState = (item, isOpen) => {
      const menuToggle = item.querySelector('[data-mega-menu-toggle]');
      const menu = item.querySelector('[data-mega-menu]');

      if (!menuToggle || !menu) return;

      item.classList.toggle('is-open', isOpen);
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      menuToggle.setAttribute('aria-label', `${isOpen ? 'Cerrar' : 'Abrir'} menú ${menuToggle.closest('.bc-nav-item').querySelector('.bc-nav-trigger').textContent.trim()}`);
      menu.hidden = !isOpen;
    };

    const cancelScheduledClose = (item) => {
      const timer = closeTimers.get(item);

      if (timer) {
        window.clearTimeout(timer);
        closeTimers.delete(item);
      }
    };

    const scheduleClose = (item) => {
      cancelScheduledClose(item);
      closeTimers.set(item, window.setTimeout(() => {
        setMegaState(item, false);
        closeTimers.delete(item);
      }, 240));
    };

    const closeMegaMenus = (except = null) => {
      megaItems.forEach((item) => {
        if (item !== except) {
          cancelScheduledClose(item);
          setMegaState(item, false);
        }
      });
    };

    const setMenuState = (isOpen) => {
      navigation.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', String(isOpen));
      toggle.setAttribute('aria-label', isOpen ? 'Cerrar menú' : 'Abrir menú');
      if (!isOpen) closeMegaMenus();
    };

    toggle.dataset.menuReady = 'true';
    toggle.addEventListener('click', () => {
      setMenuState(toggle.getAttribute('aria-expanded') !== 'true');
    });

    megaItems.forEach((item) => {
      const menuToggle = item.querySelector('[data-mega-menu-toggle]');
      const menu = item.querySelector('[data-mega-menu]');

      item.addEventListener('mouseenter', () => {
        if (isDesktop()) {
          cancelScheduledClose(item);
          closeMegaMenus(item);
          setMegaState(item, true);
        }
      });

      item.addEventListener('focusin', (event) => {
        if (event.target === menuToggle) return;
        cancelScheduledClose(item);
        closeMegaMenus(item);
        setMegaState(item, true);
      });

      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) setMegaState(item, false);
      });

      menu.addEventListener('mouseenter', () => cancelScheduledClose(item));
      menu.addEventListener('mouseleave', () => {
        if (isDesktop()) scheduleClose(item);
      });

      menuToggle.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = item.classList.contains('is-open');
        closeMegaMenus();
        setMegaState(item, !isOpen);
      });
    });

    header.addEventListener('mouseenter', () => {
      megaItems.forEach((item) => cancelScheduledClose(item));
    });

    header.addEventListener('mouseleave', () => {
      if (isDesktop()) megaItems.forEach((item) => scheduleClose(item));
    });

    navigation.addEventListener('click', (event) => {
      if (event.target.closest('a')) setMenuState(false);
    });

    header.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const openItem = megaItems.find((item) => item.classList.contains('is-open'));

        if (openItem) {
          setMegaState(openItem, false);
          openItem.querySelector('[data-mega-menu-toggle]').focus();
          return;
        }

        setMenuState(false);
        toggle.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) setMenuState(false);
    });

    window.addEventListener('resize', () => {
      if (!isDesktop()) {
        megaItems.forEach((item) => cancelScheduledClose(item));
        closeMegaMenus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bosque-home-projects"] && !Shopify.designMode) return;
  try {
    
  const initializeBosqueProjects = (scope = document) => {
    scope.querySelectorAll('[data-bc-projects]:not([data-bc-projects-ready])').forEach((section) => {
      section.setAttribute('data-bc-projects-ready', '');
      const rows = Array.from(section.querySelectorAll('[data-bc-project-row]'));
      const media = Array.from(section.querySelectorAll('[data-bc-project-media]'));

      const activate = (index) => {
        media.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      };

      rows.forEach((row, index) => {
        row.addEventListener('toggle', () => {
          if (!row.open) return;
          rows.forEach((otherRow) => {
            if (otherRow !== row) otherRow.open = false;
          });
          activate(index);
        });
      });
    });
  };

  initializeBosqueProjects();
  document.addEventListener('shopify:section:load', (event) => initializeBosqueProjects(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const row = event.target.closest('[data-bc-project-row]');
    if (row) row.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bosque-impact-metrics"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeImpactMetrics = (scope) => {
      scope.querySelectorAll('[data-impact-metrics]:not([data-impact-ready])').forEach((section) => {
        const track = section.querySelector('[data-impact-track]');
        const viewport = section.querySelector('.bc-impact__viewport');
        const slides = Array.from(section.querySelectorAll('[data-impact-slide]'));
        const previous = section.querySelector('[data-impact-previous]');
        const next = section.querySelector('[data-impact-next]');
        const pagination = section.querySelector('[data-impact-pagination]');

        if (!track || !viewport || slides.length < 2 || !previous || !next || !pagination) return;

        section.setAttribute('data-impact-ready', '');
        let activeIndex = 0;
        let autoplayTimer;
        let pointerId;
        let pointerStartX;
        let pointerDeltaX = 0;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const update = () => {
          const total = String(slides.length).padStart(2, '0');
          const current = String(activeIndex + 1).padStart(2, '0');
          track.style.transform = `translateX(-${activeIndex * 100}%)`;
          pagination.textContent = `${current} / ${total}`;
        };

        const goToPrevious = () => {
          activeIndex = (activeIndex - 1 + slides.length) % slides.length;
          update();
        };

        const goToNext = () => {
          activeIndex = (activeIndex + 1) % slides.length;
          update();
        };

        const pauseAutoplay = () => window.clearTimeout(autoplayTimer);

        const startAutoplay = () => {
          pauseAutoplay();
          if (reducedMotion || document.hidden) return;

          autoplayTimer = window.setTimeout(() => {
            goToNext();
            startAutoplay();
          }, 5000);
        };

        const restartAutoplay = () => {
          pauseAutoplay();
          startAutoplay();
        };

        previous.addEventListener('click', () => {
          goToPrevious();
          restartAutoplay();
        });

        next.addEventListener('click', () => {
          goToNext();
          restartAutoplay();
        });

        const resetDrag = () => {
          pointerId = undefined;
          pointerDeltaX = 0;
          viewport.classList.remove('is-dragging');
        };

        viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;

          pointerId = event.pointerId;
          pointerStartX = event.clientX;
          pointerDeltaX = 0;
          viewport.classList.add('is-dragging');
          viewport.setPointerCapture(pointerId);
          pauseAutoplay();
        });

        viewport.addEventListener('pointermove', (event) => {
          if (event.pointerId !== pointerId) return;

          pointerDeltaX = event.clientX - pointerStartX;
          track.style.transform = `translateX(calc(${-activeIndex * 100}% + ${pointerDeltaX}px))`;
        });

        const completeDrag = (event) => {
          if (event.pointerId !== pointerId) return;

          const threshold = Math.max(48, viewport.clientWidth * 0.08);
          if (pointerDeltaX <= -threshold) {
            goToNext();
          } else if (pointerDeltaX >= threshold) {
            goToPrevious();
          } else {
            update();
          }

          resetDrag();
          startAutoplay();
        };

        viewport.addEventListener('pointerup', completeDrag);
        viewport.addEventListener('pointercancel', (event) => {
          if (event.pointerId !== pointerId) return;
          update();
          resetDrag();
          startAutoplay();
        });

        viewport.addEventListener('lostpointercapture', (event) => {
          if (event.pointerId !== pointerId) return;
          update();
          resetDrag();
          startAutoplay();
        });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) pauseAutoplay();
          else startAutoplay();
        });

        startAutoplay();
      });
    };

    initializeImpactMetrics(document);
    document.addEventListener('shopify:section:load', (event) => initializeImpactMetrics(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bosque-main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const money = (value, currency) => {
      try { return new Intl.NumberFormat('es-CL', { style: 'currency', currency: currency || 'CLP', maximumFractionDigits: 0 }).format(value / 100); } catch (error) { return value; }
    };
    document.querySelectorAll('[data-bosque-product]').forEach((root) => {
      const gallery = root.querySelector('[data-gallery]');
      const slides = [...root.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
      const counter = root.querySelector('[data-gallery-counter]');
      let activeIndex = 0;
      const showSlide = (index) => {
        if (!slides.length) return;
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== activeIndex; });
        thumbs.forEach((thumb, i) => { const active = i === activeIndex; thumb.classList.toggle('is-active', active); thumb.setAttribute('aria-selected', String(active)); thumb.tabIndex = active ? 0 : -1; });
        if (counter) counter.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      };
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.index))));
      gallery?.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
      gallery?.querySelector('[data-gallery-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));

      const variantsNode = root.querySelector('[data-product-variants]');
      const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
      const variantIdInput = root.querySelector('[data-variant-id]');
      const optionSelects = [...root.querySelectorAll('select[data-option-position]')];
      const finishOptionButtons = [...root.querySelectorAll('[data-finish-option-value]')];
      const price = root.querySelector('[data-product-price]');
      const comparePrice = root.querySelector('[data-compare-price]');
      const availability = root.querySelector('[data-availability]');
      const form = root.querySelector('.bosque-product-form');
      const submit = root.querySelector('[data-add-to-cart]');
      const submitLabel = root.querySelector('[data-submit-label]');
      const submitTotal = root.querySelector('[data-submit-total]');
      const wrappingAddOn = root.querySelector('[data-wrapping-add-on]');
      const wrappingAddOnError = root.querySelector('[data-wrapping-add-on-error]');
      const currency = root.dataset.currency;
      const quantityInput = root.querySelector('.bosque-product-form__quantity-input');
      let activeVariantPrice = variants[0]?.price || 0;
      const updateSubmitTotal = () => {
        if (!submitTotal) return;
        const quantity = Math.max(Number(quantityInput?.value) || 1, Number(quantityInput?.min) || 1);
        const wrappingAddOnPrice = wrappingAddOn?.checked ? (Number(wrappingAddOn.dataset.price) || 0) * quantity : 0;
        submitTotal.textContent = money(activeVariantPrice * quantity + wrappingAddOnPrice, currency);
      };
      const updateVariant = () => {
        if (!variants.length) return;
        const selectedOptions = optionSelects.map((select) => select.value);
        const selectedVariant = variants.find((variant) => variant.options.every((option, index) => option === selectedOptions[index])) || variants[0];
        if (!selectedVariant) return;
        activeVariantPrice = selectedVariant.price;
        if (variantIdInput) variantIdInput.value = selectedVariant.id;
        if (price) price.textContent = money(selectedVariant.price, currency);
        updateSubmitTotal();
        if (comparePrice) { const hasCompare = selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price; comparePrice.hidden = !hasCompare; comparePrice.textContent = hasCompare ? money(selectedVariant.compare_at_price, currency) : ''; }
        if (availability) availability.textContent = selectedVariant.available ? 'Disponible' : 'Agotado';
        if (submit) submit.disabled = !selectedVariant.available;
        if (submitLabel) submitLabel.textContent = selectedVariant.available ? 'Agregar al Carrito' : 'Agotado';
        if (selectedVariant.featured_image?.id) { const mediaIndex = slides.findIndex((slide) => slide.dataset.mediaId === String(selectedVariant.featured_image.id)); if (mediaIndex >= 0) showSlide(mediaIndex); }
        finishOptionButtons.forEach((button) => {
          const select = root.querySelector(`select[data-option-position="${button.dataset.optionPosition}"]`);
          const selected = select?.value === button.dataset.optionValue;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
      };
      optionSelects.forEach((select) => select.addEventListener('change', updateVariant));
      finishOptionButtons.forEach((button) => button.addEventListener('click', () => {
        const select = root.querySelector(`select[data-option-position="${button.dataset.optionPosition}"]`);
        if (!select || select.value === button.dataset.optionValue) return;
        select.value = button.dataset.optionValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      wrappingAddOn?.addEventListener('change', updateSubmitTotal);
      quantityInput?.addEventListener('input', updateSubmitTotal);
      root.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => { if (quantityInput) { quantityInput.value = Math.max(Number(quantityInput.min) || 1, Number(quantityInput.value) - 1); updateSubmitTotal(); } });
      root.querySelector('[data-quantity-increase]')?.addEventListener('click', () => { if (quantityInput) { quantityInput.value = Math.max(Number(quantityInput.min) || 1, Number(quantityInput.value) + 1); updateSubmitTotal(); } });
      form?.addEventListener('submit', async (event) => {
        if (!wrappingAddOn?.checked) return;

        event.preventDefault();
        if (!form.reportValidity() || submit?.disabled) return;

        const mainVariantId = Number(variantIdInput?.value);
        const addOnVariantId = Number(wrappingAddOn.dataset.variantId);
        const quantity = Math.max(Number(quantityInput?.value) || 1, 1);
        if (!mainVariantId || !addOnVariantId) return;

        const originalLabel = submitLabel?.textContent || 'Agregar al Carrito';
        if (submit) {
          submit.disabled = true;
          submit.setAttribute('aria-busy', 'true');
        }
        if (submitLabel) submitLabel.textContent = 'Agregando…';
        if (wrappingAddOnError) wrappingAddOnError.hidden = true;

        try {
          const response = await fetch(`${root.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [
                { id: mainVariantId, quantity },
                {
                  id: addOnVariantId,
                  quantity,
                  properties: {
                    _bosque_add_on: 'wrapping',
                    _bosque_parent_variant: String(mainVariantId),
                  },
                },
              ],
            }),
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || 'No se pudo agregar el envoltorio.');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          console.error('[bosque-product] wrapping add-on error', error);
          if (wrappingAddOnError) {
            wrappingAddOnError.textContent = error.message || 'No se pudo agregar el envoltorio. Inténtalo nuevamente.';
            wrappingAddOnError.hidden = false;
          }
          if (submit) {
            submit.disabled = false;
            submit.removeAttribute('aria-busy');
          }
          if (submitLabel) submitLabel.textContent = originalLabel;
        }
      });
      showSlide(0); updateVariant();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bosque-media-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bc-media-carousel')) {
    customElements.define('bc-media-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.track = this.querySelector('[data-carousel-track]');
        this.slides = [...this.querySelectorAll('[data-carousel-slide]')];
        this.controls = this.querySelector('[data-carousel-controls]');
        this.toggle = this.querySelector('[data-carousel-toggle]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true';
        this.hovered = false;
        this.focused = false;
        const signal = this.controller.signal;
        this.querySelector('[data-carousel-next]').addEventListener('click', () => this.advance(1), { signal });
        this.querySelector('[data-carousel-previous]').addEventListener('click', () => this.advance(-1), { signal });
        this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, { signal });
        this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, { signal });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, { signal });
        this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.sync(); }, { signal });
        this.track.addEventListener('pointerdown', () => { this.paused = true; this.sync(); }, { signal });
        this.motion.addEventListener('change', () => this.sync(), { signal });
        document.addEventListener('visibilitychange', () => this.sync(), { signal });
        document.addEventListener('shopify:block:select', (event) => {
          const slide = this.slides.find((item) => item === event.target || item.contains(event.target));
          if (!slide) return;
          this.paused = true;
          this.track.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft, behavior: 'instant' });
          this.sync();
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.sync());
        this.resizeObserver.observe(this.track);
        this.sync();
      }
      sync() {
        window.clearInterval(this.timer);
        const overflowing = this.track.scrollWidth > this.track.clientWidth + 2;
        this.controls.hidden = !overflowing;
        this.toggle.hidden = this.motion.matches;
        this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.toggle.classList.toggle('is-paused', this.paused);
        if (!overflowing || this.paused || this.hovered || this.focused || this.motion.matches || document.hidden) return;
        this.timer = window.setInterval(() => this.advance(1), Math.max(2000, Number(this.dataset.interval) || 6000));
      }
      advance(direction) {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const step = this.slides[1] ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.track.clientWidth;
        let target = this.track.scrollLeft + direction * step;
        if (direction > 0 && this.track.scrollLeft >= maximum - 2) target = 0;
        if (direction < 0 && this.track.scrollLeft <= 2) target = maximum;
        this.track.scrollTo({ left: Math.max(0, Math.min(maximum, target)), behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
      disconnectedCallback() {
        window.clearInterval(this.timer);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bosque-press-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bc-press-feature-media')) {
    customElements.define('bc-press-feature-media', class extends HTMLElement {
      connectedCallback() {
        const video = this.querySelector('video');
        const playButton = this.querySelector('[data-bc-press-feature-play]');

        if (!(video instanceof HTMLVideoElement) || !(playButton instanceof HTMLButtonElement)) return;

        video.controls = false;
        playButton.addEventListener('click', () => {
          video.controls = true;
          video.muted = false;
          video.play().then(() => playButton.remove()).catch(() => {
            video.controls = true;
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bosque-project-detail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bc-project-detail]').forEach(function (projectDetail) {
    const counters = projectDetail.querySelectorAll('[data-bc-counter]');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (counters.length && !prefersReducedMotion && 'IntersectionObserver' in window) {
      const formatCounterNumber = function (value, decimals, decimalSeparator) {
        const formattedValue = decimals > 0 ? value.toFixed(decimals) : Math.round(value).toString();
        return decimalSeparator === ',' ? formattedValue.replace('.', ',') : formattedValue;
      };

      const animateCounter = function (counter) {
        const targetText = counter.dataset.bcCounterValue || counter.textContent.trim();
        const numberMatch = targetText.match(/-?\d+(?:[.,]\d+)?/);
        if (!numberMatch) return;

        const numberText = numberMatch[0];
        const targetValue = Number(numberText.replace(',', '.'));
        if (!Number.isFinite(targetValue)) return;

        const decimalSeparator = numberText.includes(',') ? ',' : '.';
        const decimalPart = numberText.split(/[.,]/)[1] || '';
        const prefix = targetText.slice(0, numberMatch.index);
        const suffix = targetText.slice(numberMatch.index + numberText.length);
        const duration = 1400;
        const startedAt = performance.now();

        const renderFrame = function (now) {
          const progress = Math.min((now - startedAt) / duration, 1);
          const easedProgress = 1 - Math.pow(1 - progress, 3);
          counter.textContent = prefix + formatCounterNumber(targetValue * easedProgress, decimalPart.length, decimalSeparator) + suffix;

          if (progress < 1) {
            window.requestAnimationFrame(renderFrame);
          } else {
            counter.textContent = targetText;
          }
        };

        counter.textContent = prefix + formatCounterNumber(0, decimalPart.length, decimalSeparator) + suffix;
        window.requestAnimationFrame(renderFrame);
      };

      const counterObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.35 });

      counters.forEach(function (counter) {
        counterObserver.observe(counter);
      });
    }

    const nextProject = projectDetail.querySelector('[data-bc-next-project]');
    if (nextProject) {
      const nextProjectOptions = Array.from(nextProject.querySelectorAll('[data-bc-next-project-option]'));
      if (nextProjectOptions.length > 1) {
        const randomOption = nextProjectOptions[Math.floor(Math.random() * nextProjectOptions.length)];
        nextProjectOptions.forEach(function (option) {
          option.hidden = option !== randomOption;
        });
      }
    }

    const shareButton = projectDetail.querySelector('[data-bc-share]');
    if (!shareButton) return;
    shareButton.addEventListener('click', async function () {
      const title = projectDetail.dataset.shareTitle || document.title;
      const url = projectDetail.dataset.shareUrl || window.location.href;
      if (navigator.share) {
        try {
          await navigator.share({ title, url });
          return;
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
      }
      if (navigator.clipboard) {
        try {
          await navigator.clipboard.writeText(url);
          shareButton.textContent = 'Enlace copiado';
          return;
        } catch (error) {
        }
      }
      const input = document.createElement('textarea');
      input.value = url;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
      shareButton.textContent = 'Enlace copiado';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
